module.exports = __webpack_public_path__ + "img/icon_footer_setting.f7a66042.png";